'use client';

import { c as _c } from "react/compiler-runtime";
import { CSSProperties } from 'react';
import { MARQUEE_FADE_WIDTH, useTextOverflow } from './useTextOverflow';
import styles from './MarqueeText.module.css';
type MarqueeTextProps = {
  text: string;
  className?: string;
  component: React.ComponentType<any>;
  componentProps?: Record<string, any>;
};
export function MarqueeText(t0) {
  const $ = _c(15);
  const {
    text,
    className: t1,
    component: Component,
    componentProps: t2
  } = t0;
  const className = t1 === undefined ? "" : t1;
  let t3;
  if ($[0] !== t2) {
    t3 = t2 === undefined ? {} : t2;
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const componentProps = t3;
  const {
    ref: containerRef,
    isOverflowing
  } = useTextOverflow();
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      "--scroll-duration": "6s",
      "--marquee-fade-width": `${MARQUEE_FADE_WIDTH}px`
    };
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const containerStyle = t4 as CSSProperties;
  const t5 = `${styles["marquee-track"]} ${isOverflowing ? styles["marquee-fade"] : ""}`;
  const t6 = `${styles["marquee-inner"]} ${isOverflowing ? styles["is-scrolling"] : ""}`;
  let t7;
  if ($[3] !== Component || $[4] !== className || $[5] !== componentProps || $[6] !== text) {
    t7 = <Component className={className} {...componentProps}>{text}</Component>;
    $[3] = Component;
    $[4] = className;
    $[5] = componentProps;
    $[6] = text;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== t6 || $[9] !== t7) {
    t8 = <div data-marquee-inner={true} className={t6}>{t7}</div>;
    $[8] = t6;
    $[9] = t7;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== containerRef || $[12] !== t5 || $[13] !== t8) {
    t9 = <div ref={containerRef} className={t5} style={containerStyle}>{t8}</div>;
    $[11] = containerRef;
    $[12] = t5;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  return t9;
}